var _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClasslinkSignIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "#E97524"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 14,
    fontFamily: "Arial, sans-serif",
    fontSize: 10,
    fontWeight: 700,
    fill: "white",
    textAnchor: "middle"
  }, "CL")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClasslinkSignIn);
export default __webpack_public_path__ + "static/media/classlinkSignIn.320877416ae396f15330d5f166bfd29e.svg";
export { ForwardRef as ReactComponent };